import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { DRCXConfigurationModel } from "../../common/models/drcx/DRCXConfigurationModel";
import { IReportModel } from "../../services/reporting-data-service/Models";
import ReportingDataService from "../../services/reporting-data-service/ReportingDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseReportDataAdHocQueryParameters = {
    groupID: number;
    configuration: DRCXConfigurationModel;
} & BaseUseQueryParameters<IReportModel>;

export function useReportAdHocData({
    groupID,
    configuration,
    enabled,
    onError,
    onSuccess
}: UseReportDataAdHocQueryParameters) {
    return useQuery<IReportModel | undefined, RestError>(
        keys.adHocData(
            // groupID,
            // report
        ),
        ({ signal }) => {
            return ReportingDataService.runReportAdhoc(
                groupID,
                configuration,
                false,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
            staleTime: 0,
            cacheTime: 0,
            keepPreviousData: false,
            refetchOnWindowFocus: false
        }
    );
}
